/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import styled from '@emotion/styled';

import useRouter from 'js/lib/useRouter';

import { Button, Grid, PageGridContainer, breakpoints } from '@coursera/cds-core';

import _t from 'i18n!nls/enterprise-admin-program-creation';

export const Padded = styled.div({}, ({}) => ({
  [breakpoints.down('xs')]: {
    padding: '0 32px',
  },
}));

export const Card = styled.div({
  background: '#FFFFFF',
  border: '1px solid #929599',
  borderRadius: '4px',
  padding: '32px',
});

export const ConfirmationCardContainer = styled.div(
  {
    background: '#FFFFFF',
    border: '1px solid #929599',
    borderRadius: '4px',
    padding: '32px',
  },
  () => ({
    [breakpoints.down('xs')]: {
      border: 'none',
    },
  })
);

export const ScreenReaderOnly = styled.div({
  position: 'absolute',
  width: '1px',
  height: '1px',
  padding: 0,
  margin: '-1px',
  overflow: 'hidden',
  clip: 'rect(0, 0, 0, 0)',
  whiteSpace: 'nowrap' /* added line */,
  border: 0,
});

const containerStyle = () =>
  css({
    transform: 'translateY(-60px)',
    [breakpoints.down('xs')]: {
      padding: 0,
    },
  });

export const ProgramCreationPageGridContainer = ({
  main,
  aside,
  titleForScreenReader,
}: {
  main: React.ReactNode;
  aside: React.ReactNode;
  titleForScreenReader: React.ReactNode;
}) => {
  return (
    <PageGridContainer maxWidth="lg" css={containerStyle()}>
      <Grid item sm={12} md={8} lg={9} component="main">
        <ScreenReaderOnly>
          <h1>{titleForScreenReader}</h1>
        </ScreenReaderOnly>
        {main}
      </Grid>
      <Grid item sm={12} md={4} lg={3} component="aside">
        {aside}
      </Grid>
    </PageGridContainer>
  );
};

export const PageFooter: React.LegacyFunctionComponentWithChildren<{ onBack?: () => void; onCancel?: () => void }> = ({
  onBack,
  onCancel,
  children,
}) => {
  const router = useRouter();
  return (
    <div
      css={{
        position: 'fixed',
        zIndex: 1,
        bottom: 0,
        left: 0,
        right: 0,
        padding: '16px 0',
        background: 'var(--cds-color-white-0)',
        borderTop: '1px solid ' + 'var(--cds-color-grey-50)',
      }}
    >
      <PageGridContainer maxWidth="lg">
        <Grid item xs={12}>
          <div css={{ display: 'flex', gap: 'var(--cds-spacing-200)' }}>
            {children}
            {onBack && (
              <Button variant="secondary" onClick={onBack} data-e2e="back">
                {_t('Back')}
              </Button>
            )}
            <Button variant="secondary" onClick={onCancel ?? (() => router.goBack())} data-e2e="cancel">
              {_t('Cancel')}
            </Button>
          </div>
        </Grid>
      </PageGridContainer>
    </div>
  );
};
